import { DateTime } from 'luxon';
import { ArchivesState } from '@greenkub-fronts/shared/interface';
import { createSlice } from '@reduxjs/toolkit';

import setYearUseCase from './usesCases/setYear/setYear.use-case';
import setMonthUseCase from './usesCases/setMonth/setMonth.use-case';
import setSearchValueUseCase from './usesCases/setSearchValue/setSearchValue.use-case';

export const ARCHIVES_FEATURE_KEY = 'archives';

const archivesReducerInit = (): ArchivesState => {
  const today = DateTime.local();
  return {
    suiviInstruction: {
      year: today.year,
      month: today.month,
      searchValue: '',
    },
  };
};

export const initialArchivesState: ArchivesState = archivesReducerInit();

const archivesSlice = createSlice({
  name: ARCHIVES_FEATURE_KEY,
  initialState: initialArchivesState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setMonthUseCase.fulfilled, (state, action) => {
      state.suiviInstruction.year = action.payload.year;
      state.suiviInstruction.month = action.payload.month;
    });
    builder.addCase(setYearUseCase.fulfilled, (state, action) => {
      state.suiviInstruction.year = action.payload.year;
      state.suiviInstruction.month = action.payload.month;
    });
    builder.addCase(setSearchValueUseCase.fulfilled, (state, action) => {
      state.suiviInstruction.searchValue = action.payload.searchValue;
    });
  },
});

export const archives = archivesSlice.reducer;
